import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/VideoSection.css';
import Carousel from '../components/Carousel';
function ContactAMZ() {




  return (
    <section className="video-section2" style={{ direction: 'ltr' }}>
      <div className="container">
    <div className="section-separator" ></div>
      {/* Support Section */}
      <div style={{
        background: 'var(--primary-black)',
        padding: '50px 40px',
        borderRadius: '20px',
        textAlign: 'center',
        border: '2px solid var(--primary-orange)'
      }}>
        <h3 style={{
          fontSize: '2.3rem',
          marginBottom: '25px',
          color: 'var(--white)'
        }}>
          ⵉⵙ ⵢⴰⴷ ⵜⵎⵏⴰⵍⴰⵜ ⵜⵉⴽⵕⴹⵉ ⵜⴰⵎⵓⵟⵟⵓⵏⵜ?
        </h3>
        <p style={{
          fontSize: '1.3rem',
          lineHeight: '1.8',
          marginBottom: '30px',
          color: 'var(--text-light)'
        }}>
          ⵓⵔ ⵜⵍⵍⵉⵜ ⵡⴰⵃⴷⴰⴽⵎ.
          <br />
        ⵜⵣⵎⵔⵎⵜ ⴰⴷ ⵜⵎⵢⴰⵡⴰⴹⵎⵜ ⴰⴽⴷ ⵓⵙⵇⵇⵉⵎ ⴰⵏⴰⵎⵓⵔ ⵏ ⵉⵣⵔⴼⴰⵏ ⵏ ⵓⴼⴳⴰⵏ ⴷ ⵜⵙⵇⵇⵉⵎⵉⵏ ⵏⵏⵙ ⵜⵉⵏⵎⵏⴰⴹⵉⵏ.
        </p>

        <div style={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          gap: '20px',
          marginTop: '30px'
        }}>

        </div>

        <div style={{
          marginTop: '40px',
          padding: '25px',
          background: 'rgba(255, 107, 53, 0.1)',
          borderRadius: '15px',
          textAlign: 'center'
        }}>
          <div style={{ marginBottom: '20px' }}>
            <div style={{ fontSize: '2.5rem', marginBottom: '12px' }}>    <img src="/images/logos/1.png" className="tab-icon4-img" /></div>
            <p style={{ fontSize: '1.2rem', color: 'var(--text-light)', lineHeight: '1.8' }}>
              <strong style={{ color: 'var(--primary-orange)', fontSize: '1.3rem' }}>ⴰⵙⵇⵇⵉⵎ ⴰⵏⴰⵎⵓⵔ ⵏ ⵉⵣⵔⴼⴰⵏ ⵏ ⵓⴼⴳⴰⵏ ⴷ ⵜⵙⵇⵇⵉⵎⵉⵏ ⵏⵏⵙ ⵙ 12</strong>
            </p>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
            gap: '15px',
            marginTop: '15px'
          }}>
            <div>
              <p style={{ fontSize: '1.05rem', color: 'var(--text-light)' }}>
                <strong style={{ color: 'var(--primary-orange)' }}>ⵜⴰⵙⴰⵡⴰⵢⵜ ⵜⴰⵍⵉⴽⵟⵕⵓⵏⵉⵜ</strong>
                <br />
                chikaya@cndh.org.ma
              </p>
            </div>
          </div>
        </div>
      </div>




            {/* Additional Platforms Section */}
            <div style={{ marginTop: '60px' }}>
              <h3 style={{
                fontSize: '2.3rem',
                marginBottom: '35px',
                textAlign: 'center',
                color: 'var(--white)'
              }}>
ⵜⵉⵎⵏⴰⴹⵉⵏ ⵏⵏⵉ ⵙ ⵜⵣⵎⵔⵎⵜ ⴰⴷ ⴷⵉⴷⵙⵏⵜ ⵜⵎⵢⴰⵡⴰⴹⵎⵜ
              </h3>

              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
                gap: '25px'
              }}>
                {[
                  {
                    icon: '/images/logos/1.png',
                    title: 'ⴰⵙⵇⵇⵉⵎ ⴰⵏⴰⵎⵓⵔ ⵏ ⵉⵣⵔⴼⴰⵏ ⵏ ⵓⴼⴳⴰⵏ',
                    contacts: [
                      { type: 'ⵜⴰⵙⴰⵡⴰⵢⵜ ⵜⴰⵍⵉⴽⵟⵕⵓⵏⵉⵜ', value: 'chikaya@cndh.org.ma' },
                      { type: 'ⴰⵙⵉⵜ', value: 'www.cndh.ma' },
                      { type: 'ⵜⵜⵉⵍⵉⴼⵓⵏ', value: '0537540000' }
                    ]
                  },
                  {
                    icon: '/images/logos/2.png',
                    title: 'ⵜⴰⵎⴰⵡⴰⵙⵜ ⵏ ⵜⴱⴷⴰⴷⵜ ⴷ ⵓⵙⵉⴷⴼ ⴰⵏⴰⵎⵓⵏ ⴷ ⵜⵡⵊⴰ',
                    contacts: [
                      { type: 'ⴰⵙⵉⵜ', value: 'gissr-amane.social.gov.ma' }
                    ]
                  },
                  {
                    icon: '/images/logos/3.png',
                    title: 'ⵜⴰⵎⵓⵔⴰⵢⵜ ⵜⴰⵎⴰⵜⴰⵢⵜ',
                    contacts: [
                      { type: 'ⴰⵙⵉⵜ', value: 'plaintes.pmp.ma' }
                    ]
                  },
                  {
                    icon: '/images/logos/4.png',
                    title: 'ⵜⴰⴷⴰⴱⵓⵜ ⵜⴰⵏⴰⵎⵓⵔⵜ ⵏ ⵓⵙⴼⵔⴽ ⴰⵎⵓⵟⵟⵓⵏ',
                    contacts: [
                      { type: 'ⴰⵙⵉⵜ', value: 'e-himaya.gov.ma' }
                    ]
                  },
                  {
                    icon: '/images/logos/5.png',
                    title: 'ⵜⴰⵊⵉⴹⵕⵎⵜ ⵜⴰⴳⵍⴷⴰⵏⵜ',
                    contacts: [
                      {  value: 'ⴰⵎⵎⴰⵙⵏ ⵏ ⵜⵊⵉⴹⵕⵎⵜ ⵜⴰⴳⵍⴷⴰⵏⵜ' }
                    ]
                  },
                  {
                    icon: '/images/logos/6.png',
                    title: 'ⵜⴰⵎⵀⵍⴰ ⵜⴰⵎⴰⵜⴰⵢⵜ ⵏ ⵜⵏⴼⵔⵓⵜ ⵜⴰⵏⴰⵎⵓⵔⵜ',
                    contacts: [
                      { type: 'ⴰⵙⵉⵜ', value: 'e-blagh.ma' }
                    ]
                  },
                  {
                    icon: '/images/logos/7.png',
                    title: 'ⵜⴰⴷⴰⴱⵓⵜ ⵜⵓⵙⵍⵉⴳⵜ',
                    contacts: [
                      { type: 'ⴰⵙⵉⵜ', value: 'www.cyberconfiance.ma' },
                      { type: 'ⴰⵙⵉⵜ', value: 'evigilance.ma' },
                      { type: 'ⵜⵜⵉⵍⵉⴼⵓⵏ', value: '06 24 40 58 89' }
                    ]
                  },
                  {
                    icon: '/images/logos/8.png',
                    title: 'ⵜⵉⵎⵙⵎⵓⵏⵉⵏ ⵏ ⵡⴰⵎⵓⵏ ⵓⵖⵔⵉⵎ ⵉⵥⵍⵉⵏ',
                    contacts: [
                      { type: '', value: 'ⵉ ⵓⵍⴽⴰⵎ ⵙ ⵡⴰⵏⵏⴰⵍ ⴷ ⵜⵡⵉⵙⵉ ⵙⴳ ⵖⵓⵔ ⵜⵎⵙⵎⵓⵏⵉⵏ ⵉⵥⵍⵉⵏ ⴳ ⵢⵉⴳⵔ ⵏ ⵓⴼⵔⴰⴳ ⵏ ⵜⵡⵜⵎⵉⵏ ⴷ ⵜⵔⴱⴰⵜⵉⵏ' }
                    ]
                  },
                  {
                    icon: '/images/logos/8.png',
                    title: 'ⵜⵉⵖⵔⴰⵙⵉⵏ ⵏ ⵓⵙⵎⴰⴳⴰⵍ ⵙ ⵜⵡⵜⵎⵉⵏ ⵜⵓⵏⴳⵉⵙⵉⵏ ⵏ ⵜⴽⵕⴹⵉ',
                    contacts: [
                      { type: '', value: 'ⵜⵉⵙⵏⴱⴹⴰⵢⵉⵏ ⵜⵉⵎⵏⵣⴰ ⴷ ⵜⵉⵏ ⵡⴰⵍⴰⵙ' },
                      { type: '', value: 'ⵉⵙⴳⵏⴰⴼⵏ ⵉⴳⴷⵓⴷⴰⵏⵏ' },
                      { type: '', value: 'ⵜⵉⵏⵓⴼⴰ ⵏ ⵍⴱⵓⵍⵉⵙ ⴷ ⵜⵊⵉⴹⵕⵎⵜ ⵜⴰⴳⵍⴷⴰⵏⵜ' }
                    ]
                  }
                ].map((platform, index) => (
                  <div key={index} style={{
                    background: 'var(--primary-black)',
                    padding: '30px',
                    borderRadius: '15px',
                    border: '1px solid rgba(255, 107, 53, 0.3)',
                    transition: 'all 0.3s ease',
                    textAlign: 'left'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-5px)';
                    e.currentTarget.style.borderColor = 'var(--primary-orange)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.borderColor = 'rgba(255, 107, 53, 0.3)';
                  }}>
                    <div style={{ fontSize: '3rem', marginBottom: '15px', textAlign: 'center' }}>
                    <img src={platform.icon} className="tab-icon4-img" />
                    </div>
                    <h4 style={{
                      fontSize: '1.3rem',
                      marginBottom: '20px',
                      color: 'var(--primary-orange)',
                      textAlign: 'left',
                      lineHeight: '1.5'
                    }}>
                      {platform.title}
                    </h4>
                    <div style={{ fontSize: '1rem', lineHeight: '2', color: 'var(--text-light)', textAlign: 'left' }}>
                      {platform.contacts.map((contact, idx) => (
                        <div key={idx} style={{ marginBottom: '10px' }}>
                          {contact.type ? (
                            <>
                              <strong>{contact.type}:</strong> {contact.value}
                            </>
                          ) : (
                            <>• {contact.value}</>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>

            </div>
    <div className="section-separator" style={{ margin: '60px 0' }}></div>
            {/* Resources Section */}
            <Link to="/amz/chiffres">
            <div style={{ marginTop: '60px' }} >
              <h3 style={{
                fontSize: '2.3rem',
                marginBottom: '35px',
                textAlign: 'center',
                color: 'var(--white)'
              }}>
            ⵜⵉⵏⵜⴰⵎⵉⵏ ⵏ ⵜⵙⴰⵖⵓⵍⵜ
              </h3>

              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
                gap: '25px',
                textAlign: 'center',
              }}>
                {[
                  {
                    icon: '⚖️',
                    title: 'ⴰⵎⵥ ⵉⵣⵔⴼⴰⵏ ⵏⵏⵎ ⴷ ⵜⴷⵔⴼⵉⵏ ⵏⵏⵎ',
                    desc: 'ⵎⴽⴷⴰ ⵜⵏ ⵉⴼⵔⴳ ⵓⴷⵓⵙⵜⵓⵔ ⴰⵎⵖⵔⵉⴱⵉ ⴷ ⵓⵙⵍⴳⵏ ⴰⴳⵔⴰⵖⵍⴰⵏ ⵏ ⵉⵣⵔⴼⴰⵏ ⵏ ⵓⴼⴳⴰⵏ',

                  }
                ].map((resource, index) => (
                  <div key={index} style={{
                    background: 'var(--primary-black)',
                    padding: '30px',
                    borderRadius: '15px',
                    border: '1px solid rgba(255, 107, 53, 0.3)',
                    textAlign: 'center',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-5px)';
                    e.currentTarget.style.borderColor = 'var(--primary-orange)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.borderColor = 'rgba(255, 107, 53, 0.3)';
                  }}>
                    <div style={{ fontSize: '3rem', marginBottom: '15px', textAlign: 'center' }}>{resource.icon}</div>
                    <h4 style={{ fontSize: '1.4rem', marginBottom: '12px', color: 'var(--primary-orange)', textAlign: 'center' }}>
                      {resource.title}
                    </h4>
                    <p style={{ fontSize: '1.05rem', lineHeight: '1.7', color: 'var(--text-light)', textAlign: 'center' }}>
                      {resource.desc}
                    </p>
                    {resource.subtitle && (
                      <p style={{
                        fontSize: '0.95rem',
                        lineHeight: '1.6',
                        color: 'var(--text-light)',
                        marginTop: '10px',
                        fontStyle: 'italic',
                        textAlign: 'left'
                      }}>
                        {resource.subtitle}
                      </p>
                    )}
                  </div>
                ))}
              </div>
            </div>
</Link>
      </div>
    </section>
  );
}

export default ContactAMZ;
